// src/utils/s3Url.js
export function s3ImageUrl(folder, id, ext = "") {
  const bucket = process.env.REACT_APP_S3_BUCKET;
  const region = process.env.REACT_APP_AWS_REGION;
  return `https://${bucket}.s3.${region}.amazonaws.com/${folder}/${id}${ext}`;
}